<template>
  <div class='bannerBox'>
    <img style='width: 100%;height:100%;' src="@/assets/images/img.png">
    <div class='userCard'>
      <div class='topmsg'>
        <el-image v-if='ifLogin && $store.getters.userInfo' style='width: 48px;height: 48px;'
          :src="baseurl + '/' + $store.getters.userInfo.avatar" :preview-src-list="showurlList">
        </el-image>
        <img v-else style='width: 48px;height: 48px;' src="@/assets/images/icon_portrait.png">
        <span class='userbase'>
          <span v-if='$store.getters.userInfo' style='font-size:16px;color:#333333'>{{ $store.getters.userInfo.userName }}
          </span>
          <span v-if='$store.getters.userInfo' style='font-size:12px;color:#666666;'>{{ $store.getters.userInfo.nickName
          }}
          </span>
          <span v-if='!ifLogin' style='font-size:16px;color:#333333'>
            暂未登录
          </span>
          <span v-if='ifLogin && !$store.getters.userInfo' style='font-size:16px;color:#333333'>
            暂无数据
          </span>
        </span>
        <div v-Login='userInfoMsg' style='cursor: pointer;'><img src="@/assets/images/btn_edit.png">
        </div>
      </div>
      <div class='eqMsg'>
        <span class='eqNum'>
          <span style='color:#999999'>现有可预约设备</span>
          <span style="padding-bottom:10px">
            <span style='color:#333333;font-size:56px;font-weight:700'>{{ equipmentCount }}</span>
            <span style='color:#999999'>台</span>
          </span>
        </span>
        <span>
          <img src="@/assets/images/eqment.png">
        </span>
      </div>
      <div class='testbutton'><el-button type='warning' v-Login='toTest'>准入考核</el-button>
      </div>
      <div class='anotherbutton'><el-button type='primary' @click='eqmentSet'>预约设备</el-button>
      </div>
    </div>
    <Userinfo v-if="showUserinfo" :showUserinfo='showUserinfo' :thisToken='ifLogin' @cancel="cancel" />
    <admissionExamination v-if='showadmissionExamination' :showadmissionExamination='showadmissionExamination'
      @close='closeadmissionExamination'>
    </admissionExamination>
  </div>
</template>
<script>
import Userinfo from '../../views/uesr/index'
import { getToken } from '@/utils/auth'
const { APIURl } = require('@/utils/apiUrl')
export default {
  name: 'banner',
  components: {
    Userinfo
  },
  props: {
    equipmentCount: {
      default: 0
    }
  },
  data() {
    return {
      showUserinfo: false,
      ifLogin: false,
      baseurl: '',
      showurlList: [],
      showadmissionExamination: false
    }
  },
  methods: {
    userInfoMsg() {
      if (this.$store.getters.userInfo) {
        this.showUserinfo = true
      }
      else {
        this.$message({
          type: 'warning',
          message: '获取用户信息失败'
        })
      }
    },
    cancel() {
      this.showUserinfo = false;
      this.init()
    },
    init() {
      this.ifLogin = getToken()
      this.ifLogin ? this.$store.dispatch('user/setUsrmsg') : ''
      this.showurlList[0] = this.$store.getters.userInfo ? APIURl + '/' + this.$store.getters.userInfo.avatar : ''
      this.baseurl = APIURl
    },
    eqmentSet() {
      this.$router.push({ path: '/eqment' })
    },
    toTest() {
      this.$net(`/sdau/userClient/appraisal/queryAdmissionExamPaper`, 'get').then(res => {
        this.showadmissionExamination = res.data.open
        if (!res.data.open) {
          this.$message({
            type: 'warning',
            message: '未开启准入考试'
          })
        }
      })
    },
    closeadmissionExamination() {
      this.showadmissionExamination = false
    }
  },
  mounted() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
::v-deep.testbutton {
  .el-button {
    width: 272px;
    height: 48px;
    margin-top: 24px;
  }
}

::v-deep.anotherbutton {
  .el-button {
    width: 272px;
    height: 48px;
    margin-top: 16px;
  }
}

.bannerBox {
  height: 424px;
  position: relative;

  .userCard {
    position: absolute;
    width: 320px;
    height: 376px;
    background: #ffffff;
    border: 1px solid #ececec;
    opacity: 1;
    top: 24px;
    right: 184px;
    padding: 32px 24px 24px 24px;

    .topmsg {
      display: flex;
      margin-bottom: 32px;

      .userbase {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-left: 10px;
        width: 210px;
      }
    }

    .eqMsg {
      display: flex;
      justify-content: space-between;

      .eqNum {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
  }
}
</style>